import { downloadBlobData } from "@/v1/utils/downloadBlobData";
import { useTranslation } from "@/v2/hooks/useTranslation";
import { FreeSpinsSyncFailure } from "@/v2/types/FreeSpinsSync/FreeSpinsSyncResult.interface";

import { buildCsv } from "../utils/buildCsv";
import { getFailedGamesFileName } from "../utils/getFailedGamesFileName";
import { groupFailuresByGameAndReason } from "../utils/groupFailuresByGameAndReason";

/** Downloads the failures as a CSV, one row per game, currency and message. */
export const useDownloadFailedGamesCsv = (params: DownloadFailedGamesCsvParams) => {
  const { failures, targetName } = params;
  const { t } = useTranslation();

  return () => {
    const csv = buildCsv([
      [
        t("free-spin.fs-retrieval-modal.game-code"),
        t("free-spin.fs-retrieval-modal.game-id"),
        t("label.skin"),
        t("label.currency"),
        t("label.message"),
      ],
      ...groupFailuresByGameAndReason(failures).map((failure) => [
        // A skin failure has no game.
        failure.gameCode ?? "",
        failure.gameId ?? "",
        failure.skinIds.join(", "),
        // Empty when the failure is not about one currency.
        failure.currency ?? "",
        failure.reason,
      ]),
    ]);

    downloadBlobData(
      new Blob([csv], { type: "text/csv;charset=utf-8" }),
      getFailedGamesFileName(targetName, new Date()),
    );
  };
};

interface DownloadFailedGamesCsvParams {
  failures: FreeSpinsSyncFailure[];
  /** Names the file. */
  targetName: string;
}
